import {Maybe} from "../../types/Maybe";
import {RRCalendarDayType} from "../../types/RRCalendarDayType";
import {RREventType} from "../../types/RREventType";

interface Props {
    colIndex: number;
    event: RREventType;
}

export default function CalendarEmptyCellContent(props: Props) {
    const eventId = props.event.id;
    return (<td
        className={
                eventId === "WAREHOUSE" ? "bg-warehouse" :
                    props.event.eventColor ? props.event.eventColor :
                    (
                        (props.colIndex % 2 === 0 ? "bg-secondary-light" : "bg-light") +
                        (props.colIndex === 0 ? " td-left-dbl-border" : "")
                    )}>
        <div className={"w-100 w-50px h-100 cursor-pointer"} style={{height: "40px"}}>
            &nbsp;
        </div>
    </td>);
}
